import Vue from 'vue';
//import ko from '../../my_modules/knockout351/knockout-3.5.1.js';
import ko from 'knockout';
import "devexpress-reporting/dx-webdocumentviewer";

export default {
  name: "DxReportViewer",
  props: {
  },
  mounted() {
    //console.log('report name',this.$route.params.name);
    var reportName = this.$route.params.name;
    var viewerOptions = {
      reportUrl: ko.observable(reportName), // The URL of a report.
      requestOptions: {
        host: document.location.origin,
        // Use this line if you use an ASP.NET MVC backend
        //invokeAction: "/WebDocumentViewer/Invoke"
        // Uncomment this line if you use an ASP.NET Core backend
        invokeAction: "/DXXRDV"
      }
    };
    //console.log(viewerOptions);
    ko.applyBindings(viewerOptions, this.$refs.viewer);
  },
  beforeDestroy() {
    ko.cleanNode(this.$refs.viewer);
  },
  create() {
  }
}
